export const fields = [
  {
    headerName: 'Nickname*',
    field: 'nickname',
  },
  {
    headerName: 'Account',
    field: 'accountId',
  },
  {
    headerName: 'Total Equity',
    field: 'total_equity',
  },
  {
    headerName: 'Total Cash',
    field: 'total_cash',
  },
  {
    headerName: 'Open PnL',
    field: 'open_pnl',
  },
  { headerName: 'Closed PnL', field: 'closed_pnl', resizable: true },
  {
    headerName: 'Option Buying Power',
    field: 'optionBuyingPower',
  },
  {
    headerName: 'Stock Buying Power',
    field: 'stockBuyingPower',
  },
];
